import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { AxiosError, AxiosResponse } from 'axios'
import { IError } from '@unfoldrtech/portal-mic'
import {
  EReportingTimeWindow,
  EParamChannelTypeGlobal,
  ETimeBucketType,
  IReportingCategoriesChartResponse,
} from '@unfoldrtech/portal-mic/dist/src/models/core'

import { generateCorrelationId, getTimezone } from '../utils/helpers'
import {
  TDACategoriesReportChartFilters,
  TPPAdvertiserId,
  TSPCategoriesReportChartFilters,
} from '../models/types'
import { coreAPIV3 } from '../services/coreAPIV3'

export default function useGetAdvertiserReportingCategoriesChartV3({
  advertiserId,
  retailerId,
  campaignId,
  adGroupId,
  channelType,
  timeWindow,
  startDate,
  endDate,
  tzZone,
  aggregationType,
  filterBy,
  filterOperation,
  filterValue,
  name,
  status,
  enabled = true,
  suspense = true,
}: {
  enabled?: boolean
  suspense?: boolean
} & (TDACategoriesReportChartFilters | TSPCategoriesReportChartFilters) &
  TPPAdvertiserId): UseQueryResult<
  AxiosResponse<IReportingCategoriesChartResponse>,
  AxiosError<IError>
> {
  const queryKeyName = `getAdvertiserReportingCategoriesChart_${channelType}_${advertiserId}_${retailerId}`

  return useQuery(
    [queryKeyName, { start: startDate, end: endDate, channelType }],
    () => {
      return coreAPIV3.advertiserReporting().getAdvertiserCategoriesReportChart(
        advertiserId,
        generateCorrelationId(),
        retailerId,
        campaignId,
        adGroupId,
        channelType as EParamChannelTypeGlobal,
        timeWindow as unknown as EReportingTimeWindow,
        startDate,
        endDate,
        tzZone || getTimezone(),
        aggregationType as ETimeBucketType,
        filterBy,
        filterOperation,
        filterValue,
        name,
        // @ts-expect-error: fix in PORT-2535
        status
      )
    },
    {
      suspense,
      enabled,
    }
  )
}
